// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    GetCompanysBusiModelQuery,
    BaseResponseMapstringListLlmModelInfo,
    PostCompanysBusiModelBody,
    BaseResponseVoid,
} from '../../../types';

/**
 * 查询可用大模型列表
 *
 * @export
 * @tags 租户接口
 * @link [GET] /companys/busi/model
 */
export function getCompanysBusiModel(): Promise<BaseResponseMapstringListLlmModelInfo>;
export function getCompanysBusiModel(
    options: ApiOptions<never, GetCompanysBusiModelQuery>
): Promise<BaseResponseMapstringListLlmModelInfo>;
export function getCompanysBusiModel(
    options?: ApiOptions<never, GetCompanysBusiModelQuery>
): Promise<BaseResponseMapstringListLlmModelInfo> {
    return request<never, never, GetCompanysBusiModelQuery>('/companys/busi/model', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getCompanysBusiModel',
    });
}

/**
 * 保存绑定关系
 *
 * @export
 * @tags 租户接口
 * @link [POST] /companys/busi/model
 */
export function postCompanysBusiModel(data: PostCompanysBusiModelBody): Promise<BaseResponseVoid>;
export function postCompanysBusiModel(
    data: PostCompanysBusiModelBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postCompanysBusiModel(
    data: PostCompanysBusiModelBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostCompanysBusiModelBody, never, never>('/companys/busi/model', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postCompanysBusiModel',
    });
}

export const meta = [
    { tags: ['租户接口'], path: '/companys/busi/model', method: 'get' },
    { tags: ['租户接口'], path: '/companys/busi/model', method: 'post' },
];
